interface SpinnerProps {
  size?: keyof typeof sizeClasses;
  className?: string;
  color?: string;
  bgColor?: string;
}

const sizeClasses = {
  xs: "w-6 h-6",
  sm: "w-8 h-8",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-24 h-24",
};

// TODO: This is a loading spinner prototype. If used it can be moved out of the styleguide

export default function Spinner({
  size = "md",
  className = "",
  color = "text-primary",
  bgColor = "text-background",
}: SpinnerProps) {
  return (
    <div className={`${sizeClasses[size]} ${color} ${className}`}>
      <svg width="100%" height="100%" viewBox="0 0 182 182" role="img" aria-label="Loading">
        <defs>
          <mask id="spinner-mask">
            <rect x="0" y="0" width="182" height="182" fill="white" />
            <rect x="44" y="44" width="94" height="94" fill="black" />
          </mask>
        </defs>
        <g mask="url(#spinner-mask)">
          <circle
            className="spinner-orb-top-left"
            cx="91"
            cy="91"
            r="51"
            fill="currentColor"
          />
          <circle
            className="spinner-orb-bottom-right"
            cx="91"
            cy="91"
            r="51"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
